import React, { useCallback } from 'react';

import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { StackNavigationProp } from '@react-navigation/stack';

import { LANGUAGE_KEYS } from 'config/languageKeys';
import {
    TERMS_CONDITIONS_CLOSE_BUTTON_ID,
    TERMS_CONDITIONS_DESCRIPTION_ID,
    TERMS_CONDITIONS_LINK_ID,
    TERMS_CONDITIONS_TITLE_ID,
} from 'config/testID';

import { SCREEN } from 'router/screens';
import { RouteNavigationParams } from 'router/types';

import { selectLayoutConfig } from 'store/config/selectors';

import redirectToTerms from 'utils/redirectToTerms';

import DialogView from 'components/Dialog';

import { SCREEN_HELP_WEBSITE_BUTTON } from '../languagesConst';
import styles from './styles';

const {
    CLOSE_BUTTON,
    ACCESSIBILITY: {
        LOGIN: { ACCESSIBILITY_CLOSE_BUTTON },
    },
} = LANGUAGE_KEYS;

type Props = {
    navigation: StackNavigationProp<
        RouteNavigationParams,
        SCREEN.SETTINGS_TERMS_CONDITIONS
    >;
};

const TermsConditions = ({ navigation }: Props) => {
    const { primary } = useSelector(selectLayoutConfig);
    const { t } = useTranslation();

    const handleCancelTermsDialog = useCallback(() => {
        if (navigation.canGoBack()) {
            navigation.goBack();
        } else {
            navigation.reset({ routes: [{ name: SCREEN.SETTINGS }] });
        }
    }, [navigation]);

    return (
        <DialogView
            style={styles.dialog}
            title="SETTINGS_TERM_AND-CONDITIONS_TITLE"
            titleTestID={TERMS_CONDITIONS_TITLE_ID}
            description="SETTINGS_TERM_AND-CONDITIONS_DESCRIPTION"
            descriptionTestID={TERMS_CONDITIONS_DESCRIPTION_ID}
            actionButtonTitle={SCREEN_HELP_WEBSITE_BUTTON}
            actionButtonAccessibilityLabel={t(SCREEN_HELP_WEBSITE_BUTTON)}
            actionButtonTestID={TERMS_CONDITIONS_LINK_ID}
            actionButtonOnPress={redirectToTerms}
            cancelButtonTitle={CLOSE_BUTTON}
            cancelButtonAccessibilityLabel={t(ACCESSIBILITY_CLOSE_BUTTON)}
            closeButtonTestID={TERMS_CONDITIONS_CLOSE_BUTTON_ID}
            cancelButtonOnPress={handleCancelTermsDialog}
            cancelButtonFillColor={primary}
            actionButtonStyle={styles.button}
            actionButtonTextStyle={styles.actionButtonText}
            cancelButtonStyle={styles.button}
            cancelButtonTextStyle={styles.cancelButtonText}
            actionButtonBordered
            visible
            revertButtons
        />
    );
};

export default TermsConditions;
